<template>
  <div>
    <GradeClassStudentSelect @changed="gradeClassStudentChange" />
    <div class="d-flex mt-4">
      <DateIOSPicker style="width: 32%" label="Từ ngày" outlined dense outline :date.sync="from" />
      <DateIOSPicker
        style="width: 32%"
        class="ml-6"
        label="Đến ngày"
        outlined
        dense
        hide-details
        outline
        :date.sync="to"
      />
    </div>
    <div class="d-flex justify-end mt-6">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker'
import { mapActions, mapMutations } from 'vuex'
import { get } from 'lodash'
import moment from 'moment'
export default {
  components: { GradeClassStudentSelect, DateIOSPicker },
  data() {
    return {
      selectedGrade: {},
      selectedClass: {},
      selectedStudent: {},
      from: null,
      to: null,
      get,
    }
  },
  methods: {
    ...mapActions({ fetchItems: 'studentCreditUsage/fetch', countItems: 'studentCreditUsage/countItems' }),
    ...mapMutations({
      setQuery: 'studentCreditUsage/setQuery',
      setLoading: 'studentCreditUsage/setLoading',
    }),
    gradeClassStudentChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
      this.selectedStudent = data.student
    },
    async onFilterChanged() {
      try {
        this.setLoading(true)

        const params = {
          grade: get(this.selectedGrade, 'id', null),
          class: get(this.selectedClass, 'id', null),
          student: get(this.selectedStudent, 'id', null),
          createdAt_gte: get(this, 'from', null),
          createdAt_lte: this.to !== null ? moment(this.to).endOf('day').toISOString() : null,
        }

        await this.fetchItems({ ...params, type: 'in', _start: 0, _limit: 5 })
        await this.countItems({ ...params, type: 'in' })
        this.setQuery(params)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.setLoading(false)
      }
    },
  },
}
</script>

<style></style>
